import {GridSeeker, RadioGroupSeeker, TextFieldSeeker} from "ui-seeker/core"
import React from "react"
import {useContextSelector} from "use-context-selector";
import {AppCalendarEventsContext} from "../../Providers";


const sliderMarks = [
    { value: '1', label: 'Low' },
    { value: '2', label: 'Medium' },
    { value: '3', label: 'High' }
];


export default function EventCreationForm({ updateForm }) {
    const formData = useContextSelector(AppCalendarEventsContext, ({ state }) => state.formData)
    const { title, description, relevance } = formData
    return <>
        <GridSeeker size={12} className="event-name">
            <TextFieldSeeker id="title" value={title} label="Name" variant="standard" onChange={e => updateForm({ title: e.target.value })} />
        </GridSeeker>
        <GridSeeker size={12} className="event-description">
            <TextFieldSeeker id="description" value={description} label="Description" variant="standard" onChange={e => updateForm({ description: e.target.value })} />
        </GridSeeker>
        <GridSeeker size={12} className="date-type">
            <RadioGroupSeeker dataRadioGroup={sliderMarks} formLabel="Relevance" defaultValue={relevance.toString()} onChange={e => updateForm({ relevance: e.target.value })} />
        </GridSeeker>
    </>
}